// src/components/CountdownTimer.tsx

interface CountdownTimerProps {
  secondsRemaining: number;
  totalSeconds: number;
}

export function CountdownTimer({ secondsRemaining, totalSeconds }: CountdownTimerProps) {
  const progress = ((totalSeconds - secondsRemaining) / totalSeconds) * 100;

  return (
    <div className="w-full max-w-2xl mx-auto mt-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-lg font-medium text-gray-700">
          Recording...
        </span>
        <span className="text-2xl font-bold text-blue-600">
          {secondsRemaining}s
        </span>
      </div>

      <div className="w-full bg-gray-200 rounded-full h-3">
        <div
          className="bg-blue-600 h-3 rounded-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>

      <p className="text-sm text-gray-600 mt-2 text-center">
        Please stay still
      </p>
    </div>
  );
}
